import React from 'react';
import { Tooltip } from 'react-tooltip';

import Select from '@components/uikit/Select/Select';

import { getAITypesList } from '@helpers/getAITypesList';
import { getAIUrgenciesList } from '@helpers/getAIUrgenciesList';

import useTranslation from '@hooks/useTranslation';

import { selectSensorAiType, selectSensorAiUrgency, useSensorStoreActions } from '../../store/useSensorStore';
import style from './style.module.scss';

interface IProps {
  id: string;
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
}

const AdditionalSensorsFilters: React.FC<IProps> = ({ id, isOpen, setIsOpen }) => {
  const { t } = useTranslation();

  const { setSensorAiUrgency, setSensorAiType } = useSensorStoreActions();
  const sensorAiUrgency = selectSensorAiUrgency();
  const sensorAiType = selectSensorAiType();

  const typesList = getAITypesList(t);
  const urgenciesList = getAIUrgenciesList(t);

  return (
    <Tooltip
      id={id}
      className={style.additionalFilters}
      clickable
      openOnClick
      isOpen={isOpen}
      setIsOpen={(open) => {
        setIsOpen(open);
      }}
      render={() => {
        return (
          <div className={style.additionalFiltersContainer}>
            <div className={style.additionalFiltersTitle}>{t('Additional Filters')}</div>
            <Select
              value={sensorAiType}
              onChange={(value: string) => setSensorAiType(value)}
              label={t('Action Items Type')}
              options={typesList}
              itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'label' }}
              dataQa="ai-type-select"
              type="woHelperText"
            />
            <Select
              value={sensorAiUrgency}
              onChange={(value: string) => setSensorAiUrgency(value)}
              label={t('Urgency')}
              options={urgenciesList}
              itemKeys={{ valueFieldKey: 'value', labelFieldKey: 'label' }}
              dataQa="ai-urgency-select"
              type="woHelperText"
            />
          </div>
        );
      }}
    />
  );
};

export default AdditionalSensorsFilters;
